import { render, staticRenderFns } from "./Standmans.vue?vue&type=template&id=3c12d786&scoped=true&"
import script from "./Standmans.vue?vue&type=script&lang=ts&"
export * from "./Standmans.vue?vue&type=script&lang=ts&"
import style0 from "./Standmans.vue?vue&type=style&index=0&id=3c12d786&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c12d786",
  null
  
)

export default component.exports